/* Fernwood House v4 section reveals (Horizon 4.x). No scroll listeners.
   A section is hidden only when this script runs, motion is allowed, we are not
   in the theme editor, and the section starts below the fold. No JS, an error or
   an old browser means everything stays visible. Header state is pure CSS
   (Horizon's data-sticky-state). */
(() => {
  'use strict';
  const MAX_STAGGER = 5;

  // Card photos (fh-product-duo) get their sources after window load, so they don't
  // compete with the hero image for bandwidth. Runs for everyone, including reduced motion.
  const loadDeferredImages = () => {
    document.querySelectorAll('img[data-fh-src]').forEach((img) => {
      if (img.dataset.fhSrcset) img.srcset = img.dataset.fhSrcset;
      img.src = img.dataset.fhSrc;
      img.style.visibility = '';
      img.removeAttribute('data-fh-src');
    });
  };
  if (document.readyState === 'complete') loadDeferredImages();
  else window.addEventListener('load', loadDeferredImages, { once: true });

  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;
  const main = document.getElementById('MainContent');
  if (!main) return;

  const reveal = (el) => el.setAttribute('data-fh-reveal', 'done');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

  const fold = window.innerHeight || document.documentElement.clientHeight;
  const below = Array.from(main.querySelectorAll(':scope > .shopify-section')).filter(
    (s) => s.getBoundingClientRect().top >= fold
  );

  try {
    below.forEach((s) => {
      s.querySelectorAll('[data-fh-stagger]').forEach((group) => {
        Array.from(group.children).forEach((child, i) => child.style.setProperty('--fh-i', String(Math.min(i, MAX_STAGGER))));
      });
      s.setAttribute('data-fh-reveal', 'pending');
      io.observe(s);
    });
  } catch (error) {
    io.disconnect();
    below.forEach(reveal);
    console.error('[fh-motion] reveal setup failed; showing all sections', error);
  }
  window.addEventListener('beforeprint', () => below.forEach(reveal));
})();